
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'LinkedinBrands' })
export default class LinkedinBrands extends Vue {}
